import { render, staticRenderFns } from "./AssetVersionsTab.vue?vue&type=template&id=51feca2b&scoped=true&"
import script from "./AssetVersionsTab.vue?vue&type=script&lang=js&"
export * from "./AssetVersionsTab.vue?vue&type=script&lang=js&"
import style0 from "./AssetVersionsTab.vue?vue&type=style&index=0&id=51feca2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51feca2b",
  null
  
)

export default component.exports